module.exports = __webpack_public_path__ + "assets/menu-info-icon-186790.svg";